export class Emitter<Events extends Record<string, unknown>> {
  private listeners = new Map<keyof Events, Set<(value: never) => void>>();

  on<K extends keyof Events>(event: K, fn: (value: Events[K]) => void): () => void {
    let set = this.listeners.get(event);
    if (!set) this.listeners.set(event, (set = new Set()));
    set.add(fn as (value: never) => void);
    return () => set.delete(fn as (value: never) => void);
  }

  emit<K extends keyof Events>(event: K, value: Events[K]): void {
    const set = this.listeners.get(event);
    if (set) for (const fn of set) (fn as (value: Events[K]) => void)(value);
  }
}
